// The server renders `<link rel="canonical">` per URL (_partials/_hreflangs.slim) and only on
// indexable pages, so the tag is rewritten in place and never created: a noindex page keeps
// shipping without one. Mirrors the partial, which downcases the URL and drops the query string.
export const setCanonicalUrl = () => {
  if (typeof document === 'undefined') return

  const { origin, pathname } = window.location
  document.querySelector('link[rel="canonical"]')?.setAttribute('href', `${origin}${pathname}`.toLowerCase())
}

export default setCanonicalUrl
